import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, catchError, throwError } from 'rxjs';
import { environment as ENV } from '../../../environments/environment';
import { URL_MAP } from '../../shared/urlMap';

export interface MotivoCierreItem {
  id: number;
  valor: string;
}

export interface MotivosCierreData {
  motivoCierreIndividual: MotivoCierreItem[];
  motivoCierreColectivo: MotivoCierreItem[];
}

export interface MotivosCierreResponse {
  status: boolean;
  codeStatus: string;
  message: string;
  data: MotivosCierreData;
  errorMessage: string | null;
}

@Injectable({
  providedIn: 'root'
})
export class MotivosCierreService {
  private readonly apiUrl = `${ENV.HOST}${URL_MAP.API.COTIZADOR_MOTIVOS_CIERRE}`;

  constructor(private httpClient: HttpClient) {}

  getMotivosCierre(): Observable<MotivosCierreResponse> {
    return this.httpClient
      .get<MotivosCierreResponse>(this.apiUrl)
      .pipe(
        catchError(error => {
          console.error('Error en getMotivosCierre:', error);
          return throwError(() => error);
        })
      );
  }
}
